import { useMutation, useQueryClient } from "@tanstack/react-query";
import { systemCopyService } from "@/services/system-copy-service";
import { tenantCatalogKeys } from "@/components/pages/tenants/hooks/useTenants";
import { hotelKeys } from "@/components/pages/hotels/hooks/useHotels";
import { CopyHotelRequestDto, CopyTenantRequestDto } from "@/types/system-copy";

export const useCopyTenant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: CopyTenantRequestDto) =>
      systemCopyService.copyTenant(dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tenantCatalogKeys.lists() });
      queryClient.invalidateQueries({ queryKey: hotelKeys.lists() });
    },
  });
};

/**
 * `tenantId` in tenant mode (`?tenantId=`, platform admins): the request
 * carries it in `x-tenant-id` (DV-168).
 */
export const useCopyHotel = (tenantId?: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: CopyHotelRequestDto) =>
      systemCopyService.copyHotel(dto, tenantId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: hotelKeys.lists() });
    },
  });
};
